import Vue from "vue";
import router from "./router";
import vueCookie from "vue-cookies";
import store from "./store";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ja";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";

// import firebase from "firebase";

Vue.use(ElementUI, { locale });
Vue.use(vueCookie);

let app;

// firebase.auth().onAuthStateChanged(function(user) {
// if (user) {
// store.commit("SET_UID", { uid: user.uid });
// }
// if (!app) {
app = new Vue({
  el: "#app",
  router: router,
  store: store,
  template: "<App/>",
  components: { App },
  mounted() {}
});
// }
// });
